CTAMap.queue = {
  disabled: false,
  current: 0,
};

CTAMap.queue.start = function (setCoordinates) {
  setCoordinates =
    typeof setCoordinates !== 'undefined' && setCoordinates ? true : false;
  CTAMap.queue.current++;

  var current = CTAMap.queue.current;
  CTAMap.view.showLoading();

  setTimeout(function () {
    if (current === CTAMap.queue.current) {
      //execute last request
      CTAMap.view.printResults(setCoordinates);
    }
  }, 500);
};

CTAMap.queue.disableUntilMapIdle = function (message) {
  if (message && CTA.debug) {
    console.log(message);
  }
  CTAMap.queue.disabled = true;
  var listener = google.maps.event.addListener(
    CTAMap.map.obj,
    'idle',
    function () {
      CTAMap.queue.disabled = false;
      google.maps.event.removeListener(listener);
    }
  );
};
